const isNationSafeDriversEmail = (email) => {
  const substringsArray = ['@nationsafedrivers.com', '@gonsd.com'];
  return substringsArray.some(substring => email?.toLowerCase().includes(substring));
};

export { isNationSafeDriversEmail };
